import React, {Component} from 'react';
import {roundigFormat} from '../libs/utils/Operations';
import '../css/dataTables.css';
const momentTz = require('moment-timezone');
const objectCode = (param) =>{
    let name = param;
         switch (param) {
            case '17':
                name = "Orden venta";
                break;
            case '15':
                name = "Entregas";
                break;
            case '13':
                name = "Factura";
                break;
            case '16':
                name = "Devolución";
                break;
            case '21':
                name = "purchaseReturn";
                break;
            case '24':
                name = "Pago";
                break;
            case '67':
                name = "transfers";
                break;
            case '1250000001':
                break;
            case '59':
                name = "transfersEntry";
                break;
            case '60':
                name = "transfersOutput";
                break;
            case '14':
                name = "Nota de crédito";
                break;
            case '22':
                name = "PurchaseOrder";
                break;
            case '20':
                name = "GoodsReceipt";
                break;
            case '1470000113':
                name = "PurchaseRequest";
                break;
            case '162':
                name = "inventoryRevaluation";
                break;
            
            case '18':
                name = "purchaseInvoice";
                break;
            case '30':
                name = "outgoingPayment";
                break;
        }
    return name;
}

const renderTableBody = (headers, data, action) => {
    let body: "";
    
    body = data.map((payment, index) => {

        return (
            <tr key={index}>
               
                <td>{payment.DocNum || ""}</td>
                <td>{momentTz(payment.DocDate).utc().format('DD/MM/YYYY') || ""}</td>
                <td>{momentTz(payment.DocDueDate).utc().format('DD/MM/YYYY') || ""}</td>
                <td>{payment.Total || 0}</td>                
            </tr>
        )
    })

    return body;
};

const renderTable = (headers, data, action) => {
    let header = "";
    let body = "";

    if (headers.length != 0) {
        header = <tr>
            {/* <td className="sticky-header table-header-yellow "></td> */}
            <td className="sticky-header table-header-yellow ">{headers[0].title}</td>
            <td className="sticky-header table-header-yellow ">{headers[1].title}</td>
            <td className="sticky-header table-header-yellow ">{headers[2].title}</td>
            <td className="sticky-header table-header-yellow ">{headers[3].title}</td>
        </tr>;
    }

    body = renderTableBody(headers, data, action);

    let table = "";

    table =
        <div className="table-wrapper-scroll-y my-custom-scrollbar">
            <table id="dataTableCreate" className="display" style={{width: '100%'}}>
                <thead className="table-header">
                {header}
                </thead>
                <tbody>
                {body}
                </tbody>
            </table>
        </div>;

    return table;

};

export const renderTablePaymnetListModal = (headers, data, action) => {

    return renderTable(headers, data, action);

}
